






























































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { GetSampleOrderPage } from '@/pages/user/api/sample-order';

type OrderTab = 'ALL' | 'UNPAID' | 'PRODUCING' | 'FINISHED' | 'CANCELED';

type OrderItem = {
  orderSn: string;
  orderStatus: string;
  orderStatusName: string;
  createdAt: string;
  productName: string;
  productImageUrl: string;
  sizeName: string;
  unitPrice: number | string;
  quantity: number;
  payableAmount: number | string;
  fileUrl: string;
  fileName?: string;
  contactName: string;
  contactPhone: string;
  provinceName?: string;
  cityName?: string;
  districtName?: string;
  addressDetail?: string;
  expressCompany?: string;
  trackingNo?: string;
};

function normalizeArray<T>(value: T[] | null | undefined): T[] {
  return Array.isArray(value) ? value : [];
}

@Component
export default class MyOrder extends Vue {
  @Watch('$route', { immediate: false })
  onRouteChange() {
    this.initQueryFromRoute();
    this.fetchOrderList();
  }

  pageLoading = false;
  total = 0;
  orderList: OrderItem[] = [];

  tabs: Array<{ label: string; value: OrderTab }> = [
    { label: '全部订单', value: 'ALL' },
    { label: '待支付', value: 'UNPAID' },
    { label: '制作中', value: 'PRODUCING' },
    { label: '已完成', value: 'FINISHED' },
    { label: '已取消', value: 'CANCELED' },
  ];

  query = {
    keyword: '',
    tab: 'ALL' as OrderTab,
    pageNum: 1,
    pageSize: 10,
  };

  async mounted() {
    this.initQueryFromRoute();
    await this.fetchOrderList();
  }

  initQueryFromRoute() {
    const orderSn = this.$route.query.orderSn;
    this.query.keyword = typeof orderSn === 'string' && orderSn.trim() ? orderSn.trim() : '';
    this.query.pageNum = 1;
  }

  async fetchOrderList() {
    this.pageLoading = true;
    try {
      const res = await GetSampleOrderPage({ ...this.query });
      this.orderList = normalizeArray<OrderItem>(res && res.records);
      this.total = Number((res && res.total) || 0);
    } finally {
      this.pageLoading = false;
    }
  }

  handleTabChange(tab: OrderTab) {
    this.query.tab = tab;
    this.query.pageNum = 1;
    this.fetchOrderList();
  }

  handleSearch() {
    this.query.pageNum = 1;
    this.fetchOrderList();
  }

  handlePageNumChange(pageNum: number) {
    this.query.pageNum = pageNum;
    this.fetchOrderList();
  }

  handlePageSizeChange(pageSize: number) {
    this.query.pageSize = pageSize;
    this.query.pageNum = 1;
    this.fetchOrderList();
  }

  handleDownload(item: OrderItem) {
    if (!item.fileUrl) {
      this.$message.warning('未找到打样稿');
      return;
    }
    window.open(item.fileUrl, '_blank');
  }

  formatPrice(value: number | string) {
    return Number(value || 0).toFixed(2);
  }

  formatDate(value: string) {
    return value ? value.replace('T', ' ') : '--';
  }

  buildAddress(item: OrderItem) {
    return [item.provinceName, item.cityName, item.districtName, item.addressDetail].filter(Boolean).join('');
  }

  getStatusClass(status: string) {
    if (status === 'CANCELED') {
      return 'is-canceled';
    }
    if (status === 'FINISHED' || status === 'SHIPPED') {
      return 'is-finished';
    }
    if (status === 'IN_PRODUCTION') {
      return 'is-producing';
    }
    return 'is-created';
  }
}
